import Icon from 'veui/components/Icon'
import { IconHeadphones } from 'dls-icons-vue'

Icon.register('headphones', IconHeadphones)
